// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';

function EngravingApproved() {
    return (
        <div className="main-container">
            <NavbarPrimary hideNav />
            <div className="body-content">
                <PageTitle title="Artwork approved" />

                <ContentCard
                    className="mt-62"
                    headerTitle="Thank you"
                    divider={false}
                >
                    <Container fluid className="engraving-container">
                        <Row>
                            <Col md={12}>
                                <p>
                                    Artwork has been approved and submitted to Lawnswood for engraving.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </ContentCard>
            </div>
        </div>
    );
}

export default withRouter(EngravingApproved);
